export interface Location {
  latitude: number;
  longitude: number;
}
export const calcCenter = (locations: Location[]) => {
  if (locations.length === 0) return null;
  const total = locations.reduce((acc: Location, location: Location) => {
    return {
      latitude: acc.latitude + location.latitude,
      longitude: acc.longitude + location.longitude
    }
  }, { latitude: 0, longitude: 0 });
  return {
    latitude: total.latitude / locations.length,
    longitude: total.longitude / locations.length
  }
}
export interface Boundary {
  s: number;
  n: number;
  w: number;
  e: number;
}
export const mergeBoundary = (boundaries: Boundary[]) => {
  return boundaries.reduce((b, a, index) => {
    return index === 0 ? a : {
      s: Math.min(b.s, a.s), n: Math.max(b.n, a.n),
      w: Math.min(b.w, a.w), e: Math.max(b.e, a.e)
    }
  }, { s: 0, n: 0, w: 0, e: 0 });
}